import { LOCALES } from "../locales";

const frenchLocals = {
  [LOCALES.FRENCH]: {
    ESS: "AEG",
    ociety: "énie",
    Home: "Accueil",
    About: "À propos",
    "Who We Are": "Qui sommes-nous",
    "Our Team": "Notre équipe",
    "Past Team": "Ancienne équipe",
    "Join Our Team": "Joignez notre équipe",
    "Affiliated Groups": "Groupes affiliés",
    "Contact Us": "Contactez-nous",
    Resources: "Ressources",
    "Scholarships and Careers": "Bourses et carrières",
    "Important Documents": "Documents Importants",
    "School Support": "Soutien scholaire",
    "Incident Reports": "Reporter un incident",
    Accessibility: "Accessibilité",
    Services: "Services",
    Store: "Boutique",
    "Office Hours": "Heures de bureau",
    Lockers: "Casiers",
    "101 Week 2025": "101 semaine 2025",
    "101 Week 2024": "101 semaine 2024",
    Events: "Événements",
    "uOttawa Engineering Competition":
      "Compétition d'ingénierie de l'Université d'Ottawa",
    Conferences: "Conférences",
    "Upcoming Events": "Événements à venir",
    "Recurring Events": "Événements récurrents",
    "Engineering Charity Ball 2024": "Bal de Charité des Ingénieurs 2024",
    "Engineering Charity Ball 2025": "Bal de Charité des Ingénieurs 2025",
    "101 Week 2026": "101 semaine 2026",
    ERTW: "ERTW",
    "Engineering Students Society": "Association des étudiants en Génie",
    "Find us on Social Media": "Nos réseaux sociaux",
    "All fields marked with": "Les champs marqués par",
    "are required": "sont requis",
    Name: "Nom",
    Subject: "Sujet",
    consent_message:
      "Je comprends que ce formulaire stocke les informations que j'ai soumises afin que je puisse être contacté(e).",
    Submit: "Soumettre",
    Location: "Emplacement",
    //'Online Store': "Magasin en ligne",
    "Learn More": "En savoir plus",
    "Events Archive": "Archives des événements",
    "team.category.vps": "Vice-présidents",
    "team.category.managers": "Responsables",
    "team.category.commissioners": "Commissaires",
    "team.category.officers": "Officiers",
    "team.vacant": "Vacant",
    "team.interim": "par intérim",
    "position.president": "Président.e",
    "position.co-president": "Co-Président.e",
    "position.vp-external": "Vice-président.e aux affaires externes",
    "position.vp-finance":
      "Vice-président.e aux finances et à l'administration",
    "position.vp-academic": "Vice-président.e aux affaires académiques",
    "position.vp-comms": "Vice-président.e aux communications",
    "position.vp-internal": "Vice-président.e aux affaires internes",
    "position.vp-services": "Vice-président.e aux services",
    "position.vp-social": "Vice-président.e aux affaires sociales",
    "position.vp-phil": "Vice-président.e aux affaires philanthropiques",
    "position.vp-equity": "Vice-président.e à l'équité",
    "position.vp-sustainability": "Vice-président.e aux initiatives durables",
    "position.vp-francophone": "Vice-président.e aux affaires francophones",
    "position.vp-admin": "Vice-président.e à l'administration",
    "position.manager-101": "Coordonnateur.trice de la semaine 101",
    "position.manager-equity": "Responsable de l'équité",
    "position.manager-external-awareness":
      "Gestionnaire de la sensibilisation externe",
    "position.manager-it": "Responsable des technologies de l'information",
    "position.manager-marketing": "Responsable du marketing",
    "position.manager-office": "Responsable de bureau",
    "position.manager-social": "Responsable des médias sociaux",
    "position.manager-sponsor": "Responsable du parrainage",
    "position.manager-sports": "Responsable des sports",
    "position.manager-advocacy": "Responsable de la réussite académique",
    "position.manager-student-success":
      "Responsable de la réussite des étudiants",
    "position.manager-sustainability": "Responsable des initiatives durables",
    "position.manager-translations": "Responsable des traductions",
    "position.manager-winecheese": "Coordonnateur.trice du vin et fromage",
    "position.charity-comm": "Commissaire de charité",
    "position.francophone-outreach-comm":
      "Commissaire de diffusion francophone",
    "position.ertw-comm": "Commissaire IRSM",
    "position.finance-comm": "Commissaire aux finances",
    "position.logistics-comm": "Commissaire à la logistique du parrainage",
    "position.spirit-comm": "Commissaire de l'Esprit",
    "position.uoec-comm": "Commissaire du CIuO",
    "position.media-comm": "Commissaire aux médias",
    "position.selection-comm": "Commissaire à la sélection",
    "position.chair": "Président.e du conseil",
    "Board of Directors": "Conseil d'administration",
    "bod.group.officers": "Présidence et secrétariat",
    "bod.group.sub_associations": "Sous-associations",
    "bod.group.representatives": "Représentant.e.s",
    "bod.group.non_voting": "Membres sans droit de vote",
    "bod.seat.chair": "Président.e du conseil",
    "bod.seat.secretary": "Secrétaire",
    "bod.seat.ieee": "IEEE",
    "bod.seat.chess": "AÉGC",
    "bod.seat.mess": "SÉGM",
    "bod.seat.csce": "CSCE",
    "bod.seat.cesa": "AÉGCi",
    "bod.seat.sass": "SASS",
    "bod.seat.jmts": "JMTS",
    "bod.seat.eef": "FDG",
    "bod.seat.coop": "{program} CO-OP",
    "bod.seat.year": "{year} {program}",
    "bod.seat.rep": "Représentant.e",
    "bod.year.1": "1re année",
    "bod.year.2": "2e année",
    "bod.year.3": "3e année",
    "bod.year.4": "4e année",
    "bod.program.chemical": "chimique",
    "bod.program.civil": "civil",
    "bod.program.electrical": "électrique",
    "bod.program.mechanical": "mécanique",
    "bod.program.biomech": "biomédical mécanique",
    "bod.program.software": "logiciel",
    "bod.program.computer": "informatique",
    "bod.program.french": "français",
    "bod.program.multidisciplinary": "conception multidisciplinaire",
  },
};

export default frenchLocals;
